module.exports = __webpack_public_path__ + "img/rules-03.ad5ae9c7.svg";